const i18n = {
  supportedLngs: ['en'],
  fallbackLng: 'en',
  defaultNS: 'common',
};

export default i18n;
